import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import { db } from "../firebase";
import "./Achievements.css";

function Achievements() {
  const { t, i18n } = useTranslation();

  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);

  const isArabic = i18n.language === "ar";

  useEffect(() => {
    fetchAchievements();
  }, []);

  const fetchAchievements = async () => {
    try {
      setLoading(true);

      const q = query(
        collection(db, "achievements"),
        orderBy("createdAt", "desc")
      );

      const snapshot = await getDocs(q);

      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setAchievements(data);
    } catch (error) {
      console.error("Error fetching achievements:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`achievements-page ${isArabic ? "rtl" : "ltr"}`}
      dir={isArabic ? "rtl" : "ltr"}
    >
      {/* HERO */}
      <section className="achievements-hero">
        <div className="hero-decoration hero-decoration-one"></div>
        <div className="hero-decoration hero-decoration-two"></div>

        <div className="achievements-hero-content">
          <span className="hero-small-title">
            🏆 {t("achievements.tag")}
          </span>

          <h1>{t("achievements.title")}</h1>

          <p>{t("achievements.description")}</p>

          <div className="hero-line">
            <span></span>
            <div>★</div>
            <span></span>
          </div>
        </div>
      </section>

      {/* ACHIEVEMENTS */}
      <section className="achievements-section">
        <div className="achievements-container">
          {loading ? (
            <div className="achievements-loading">
              <div className="loading-spinner"></div>
              <p>{t("achievements.loading")}</p>
            </div>
          ) : achievements.length === 0 ? (
            <div className="empty-achievements">
              <div className="empty-icon">🏆</div>

              <h3>{t("achievements.emptyTitle")}</h3>

              <p>{t("achievements.emptyText")}</p>
            </div>
          ) : (
            <div className="achievements-grid">
              {achievements.map((achievement, index) => {
                const title = isArabic
                  ? achievement.titleAr
                  : achievement.titleEn;

                const description = isArabic
                  ? achievement.descriptionAr
                  : achievement.descriptionEn;

                return (
                  <article
                    className="achievement-card"
                    key={achievement.id}
                    style={{
                      animationDelay: `${index * 0.1}s`,
                    }}
                  >
                    {/* IMAGE */}
                    <div className="achievement-image-container">
                      {achievement.image ? (
                        <img
                          src={achievement.image}
                          alt={title || t("achievements.title")}
                          className="achievement-image"
                        />
                      ) : (
                        <div className="achievement-no-image">
                          <span>🏆</span>
                        </div>
                      )}

                      {achievement.year && (
                        <div className="achievement-year">
                          {achievement.year}
                        </div>
                      )}
                    </div>

                    {/* CONTENT */}
                    <div className="achievement-content">
                      <div className="achievement-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h2>{title}</h2>

                      {description && <p>{description}</p>}

                      <div className="achievement-bottom-line">
                        <span></span>
                        <span>★</span>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Achievements;